import Color from '../Color.js';
var digits = '0123456789abcdef';
var floor = Math.floor,
  random = Math.random;
export default (function () {
  var code = '#';
  for (var i = 0; i < 6; i++) {
    code += digits.charAt(floor(random() * 16));
  }
  return new Color(code, 'hex');
});